<template>
    <!-- Ver la nota de EnVivo.vue: sin este wrapper el header tapa el encabezado. -->
    <v-content>
    <v-container>
        <v-card>
            <v-card-title class="flex-wrap">
                Recorridos
                <v-spacer/>
                <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        persistent
                        width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                                v-model="date"
                                label="Fecha"
                                prepend-icon="event"
                                readonly
                                hide-details
                                class="mx-2"
                                style="max-width: 190px"
                                v-on="on"
                        />
                    </template>
                    <v-date-picker v-model="date" scrollable locale="es-co" :max="hoy">
                        <v-spacer/>
                        <v-btn text color="primary" @click="cancelarFecha">Cancelar</v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)">Aceptar</v-btn>
                    </v-date-picker>
                </v-dialog>

                <v-autocomplete class="mx-2"
                        label="Buscar usuario"
                        v-model="user"
                        :items="usersList"
                        item-text="fullName"
                        item-value="id"
                        clearable
                        hide-details
                        style="max-width: 320px"
                        no-data-text="No se encontraron usuarios"
                />
                <v-btn color="primary" :loading="cargando" :disabled="cargando" @click="getTraking()">
                    Ver recorrido
                </v-btn>
            </v-card-title>

            <!-- El :key fuerza una instancia nueva de VAlert por mensaje. Sin eso, si
                 el usuario cerraba el aviso con la X, VAlert conservaba su estado
                 interno y el mismo mensaje no volvia a aparecer nunca. -->
            <v-alert v-if="errorMsg" :key="errorMsg" :type="errorTipo" dense dismissible class="mx-4">{{ errorMsg }}</v-alert>

            <!-- Resumen. Son los numeros que el supervisor necesita antes de mirar
                 el mapa: sin esto hay que deducirlos a ojo del trazado. -->
            <v-card-text v-if="resumen" class="py-2 resumen">
                <span class="dato">
                    <strong>{{ resumen.duracion }}</strong> con registro
                    <span v-if="huecos.length" class="text--secondary">(de {{ resumen.span }} entre el primer y el ultimo punto)</span>
                </span>
                <span class="dato"><strong>{{ resumen.km }}</strong> km</span>
                <span class="dato"><strong>{{ resumen.puntos }}</strong> puntos</span>
                <span class="dato" v-if="detenciones.length"><strong>{{ detenciones.length }}</strong> detencion(es)</span>
                <span class="dato alerta" v-if="huecos.length"><strong>{{ huecos.length }}</strong> hueco(s) sin señal</span>
                <!-- La doble marca temporal no sirve de nada si hay que abrir punto por
                     punto para verla: con 20.000 puntos nadie la mira. Aca se resume. -->
                <span class="dato alerta" v-if="relojSospechoso">
                    <strong>{{ relojSospechoso.cuantos }}</strong> punto(s) con el reloj del telefono desfasado
                    (hasta {{ relojSospechoso.texto }})
                </span>
                <span class="dato aviso" v-if="sinMarcaServidor > 0">
                    {{ sinMarcaServidor }} punto(s) sin marca de servidor (version anterior de la app)
                </span>
                <span class="dato aviso" v-if="descartados > 0">
                    {{ descartados }} punto(s) descartado(s)<span v-if="simulados > 0">, {{ simulados }} por ubicacion simulada</span>
                </span>
                <span class="dato alerta" v-if="intentosSimulacion > 0">
                    <strong>{{ intentosSimulacion }}</strong> intento(s) de ubicacion simulada rechazado(s)
                </span>
            </v-card-text>

            <GmapMap
                    ref="mapa"
                    :options="{
                       zoomControl: true,
                       mapTypeControl: false,
                       scaleControl: false,
                       streetViewControl: false,
                       rotateControl: false,
                       fullscreenControl: true,
                       disableDefaultUi: false
                     }"
                    :center="centro"
                    :zoom="12"
                    map-type-id="roadmap"
                    style="width: 100%; height: 460px"
            >
                <template v-if="google">
                    <!-- Un trazado por segmento. Los segmentos se cortan donde hay un
                         hueco de tiempo: antes era UNA sola polilinea sobre todos los
                         puntos del dia, asi que un hueco de cuatro horas se dibujaba
                         como una recta prolija. El panel no ocultaba el vacio, lo
                         rellenaba con un trayecto que nunca ocurrio. -->
                    <GmapPolyline
                            v-for="(seg, i) in segmentos"
                            :key="'seg' + i"
                            :editable="false"
                            :path="seg"
                            :options="{ geodesic: false, strokeColor: '#D32F2F', strokeOpacity: 0.85, strokeWeight: 4, icons: flechas }"
                    />

                    <!-- Los huecos se dibujan, pero punteados y en gris: se ve que ahi
                         no hay evidencia, en lugar de fingirla. -->
                    <GmapPolyline
                            v-for="(h, i) in huecos"
                            :key="'hueco' + i"
                            :editable="false"
                            :path="[{ lat: h.desde.lat, lng: h.desde.lng }, { lat: h.hasta.lat, lng: h.hasta.lng }]"
                            :options="{ geodesic: false, strokeOpacity: 0, icons: puntitos }"
                    />

                    <GmapMarker
                            v-for="(h, i) in huecos"
                            :key="'mh' + i"
                            :position="{ lat: (h.desde.lat + h.hasta.lat) / 2, lng: (h.desde.lng + h.hasta.lng) / 2 }"
                            :icon="iconoHueco"
                            :label="{ text: minutosCortos(h.minutos), color: '#616161', fontSize: '11px', fontWeight: 'bold' }"
                            :clickable="true"
                            @click="abrirHueco(h)"
                    />

                    <!-- Detenciones: los puntos que se acumulan en un radio chico
                         durante varios minutos se muestran como UNA parada con su
                         duracion. Ademas de limpiar la telaraña sobre la garita,
                         produce el dato que antes no existia en ninguna parte:
                         cuanto tiempo estuvo quieto y donde. -->
                    <GmapMarker
                            v-for="(d, i) in detenciones"
                            :key="'det' + i"
                            :position="{ lat: d.lat, lng: d.lng }"
                            :icon="iconoDetencion"
                            :label="{ text: minutosCortos(d.minutos), color: '#FFFFFF', fontSize: '10px', fontWeight: 'bold' }"
                            :clickable="true"
                            @click="abrirDetencion(d)"
                    />
                </template>

                <gmap-custom-marker
                        v-if="puntos.length > 0"
                        :marker="puntos[0]"
                        :draggable="false"
                        :clickable="true"
                        :offset-y="-25"
                >
                    <img :src="require('@/assets/start.svg')" height="50" @click="openModal(puntos[0])" alt="inicio"/>
                </gmap-custom-marker>

                <gmap-custom-marker
                        v-if="puntos.length > 1"
                        :marker="puntos[puntos.length - 1]"
                        :draggable="false"
                        :clickable="true"
                        :offset-y="-25"
                >
                    <img :src="require('@/assets/finish.svg')" height="50" @click="openModal(puntos[puntos.length - 1])" alt="fin"/>
                </gmap-custom-marker>
            </GmapMap>
        </v-card>

        <!-- Detalle de un punto -->
        <v-dialog width="520" v-model="dialog">
            <v-card v-if="dialog && markerInfo">
                <v-card-title class="subtitle-1">
                    {{ markerInfo.t | moment("dddd D [de] MMMM [de] YYYY, HH:mm:ss") }}
                </v-card-title>
                <v-divider/>
                <v-simple-table dense>
                    <tbody>
                    <tr>
                        <td class="grey--text">Vigilante</td>
                        <td>{{ nombreDe(usuarioRecorrido) }}</td>
                    </tr>
                    <tr>
                        <td class="grey--text">Coordenadas</td>
                        <td>{{ markerInfo.lat.toFixed(6) }}, {{ markerInfo.lng.toFixed(6) }}</td>
                    </tr>
                    <tr>
                        <td class="grey--text">Precision</td>
                        <td>
                            <span v-if="markerInfo.accuracy !== null">± {{ Math.round(markerInfo.accuracy) }} m</span>
                            <span v-else class="grey--text">no registrada (punto anterior a la version 2.5)</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="grey--text">Velocidad</td>
                        <td>
                            <span v-if="markerInfo.speed !== null">{{ (markerInfo.speed * 3.6).toFixed(1) }} km/h</span>
                            <span v-else class="grey--text">no registrada</span>
                        </td>
                    </tr>
                    <tr v-if="markerInfo.desdeAnterior">
                        <td class="grey--text">Desde el punto anterior</td>
                        <td>{{ markerInfo.desdeAnterior }}</td>
                    </tr>
                    <tr v-if="markerInfo.desfase !== null">
                        <td class="grey--text">Desfase de reloj</td>
                        <td :class="{ 'red--text': Math.abs(markerInfo.desfase) > 120 }">
                            {{ textoDesfase(markerInfo.desfase) }}
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
            </v-card>
        </v-dialog>

        <!-- Detalle de un hueco o una detencion -->
        <v-dialog width="460" v-model="dialogTramo">
            <v-card v-if="dialogTramo && tramoInfo">
                <v-card-title class="subtitle-1">
                    <v-icon left :color="tramoInfo.tipo === 'hueco' ? 'grey darken-1' : 'blue darken-2'">
                        {{ tramoInfo.tipo === 'hueco' ? 'signal_cellular_off' : 'pause_circle_filled' }}
                    </v-icon>
                    {{ tramoInfo.tipo === 'hueco' ? 'Hueco sin registro' : 'Detencion' }}
                </v-card-title>
                <v-divider/>
                <v-card-text class="pt-3">
                    <div><strong>Desde:</strong> {{ tramoInfo.desde | moment("HH:mm:ss") }}</div>
                    <div><strong>Hasta:</strong> {{ tramoInfo.hasta | moment("HH:mm:ss") }}</div>
                    <div><strong>Duracion:</strong> {{ minutosLargos(tramoInfo.minutos) }}</div>
                    <v-alert v-if="tramoInfo.tipo === 'hueco'" type="warning" dense text class="mt-3 mb-0 caption">
                        En este intervalo no hay posiciones registradas. Puede ser falta de
                        señal, GPS apagado o la app cerrada. La linea punteada no es un
                        recorrido: solo une los dos extremos del hueco.
                    </v-alert>
                    <v-alert v-else type="info" dense text class="mt-3 mb-0 caption">
                        El vigilante permanecio en un radio de {{ RADIO_DETENCION }} m durante este tiempo.
                    </v-alert>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
    </v-content>
</template>

<script>
    import GmapCustomMarker from 'vue2-gmap-custom-marker';
    import { gmapApi } from 'vue2-google-maps';
    import { mapState } from "vuex";
    import { db } from "@/plugins/db";

    // Tamaño de pagina y techo duro. Antes la consulta no tenia `limit` ni cursor:
    // un turno con deriva de GPS podia traer decenas de miles de documentos de
    // golpe y colgar la pestaña.
    const PAGINA = 2000;
    const MAX_PUNTOS = 20000;

    // Minutos de silencio a partir de los cuales se considera que hubo un hueco y
    // el trazado se corta.
    const HUECO_MINUTOS = 5;

    // Una detencion es permanecer dentro de este radio durante al menos este tiempo.
    const RADIO_DETENCION = 25;
    const DETENCION_MINUTOS = 3;

    export default {
        name: "Tracking",
        components: {
            'gmap-custom-marker': GmapCustomMarker
        },
        data () {
            return {
                RADIO_DETENCION,
                centro: { lat: 4.6097, lng: -74.0817 },
                date: this.$moment().format('YYYY-MM-DD'),
                fechaPrevia: this.$moment().format('YYYY-MM-DD'),
                user: '',
                puntos: [],
                segmentos: [],
                huecos: [],
                detenciones: [],
                descartados: 0,
                simulados: 0,
                // Intentos de ubicacion simulada RECHAZADOS por la app. No salen de
                // `tracking` -esos puntos nunca se guardan- sino de la coleccion de
                // alertas de integridad.
                intentosSimulacion: 0,
                truncado: false,
                cargando: false,
                modal: false,
                dialog: false,
                dialogTramo: false,
                markerInfo: null,
                usuarioRecorrido: null,
                tramoInfo: null,
                errorMsg: '',
                errorTipo: 'info',
                // Token de consulta. Sin esto, dos clics seguidos mezclaban los
                // puntos de dos consultas en una sola polilinea: un recorrido que
                // nunca existio, mostrado como evidencia.
                consulta: 0,
                userPendiente: null
            }
        },
        computed: {
            google: gmapApi,

            // Computed y no data: en un centro de operaciones la pestania cruza la
            // medianoche todos los dias, y como dato congelado el `:max` del
            // calendario se quedaba en ayer.
            hoy () {
                return this.$moment().format('YYYY-MM-DD')
            },

            ...mapState({
                users: state => state.user.users
            }),

            /*
              * OJO con el `id`.
              *
              * Vuexfire define el id del documento con
              * `Object.defineProperty(doc.data(), 'id', {value: doc.id})`, o sea NO
              * ENUMERABLE: `{...u}` lo descarta en silencio. Con `item-value="id"`
              * apuntando a un campo inexistente, Vuetify cae a su valor por defecto,
              * que es el TEXTO del item (`getValue` -> `getPropertyFromItem(item,
              * itemValue, this.getText(item))`), asi que `this.user` terminaba siendo
              * "Juan Perez (VIGILANTE)" en lugar del uid.
              *
              * Resultado: `where('user.id','==','Juan Perez (VIGILANTE)')` no
              * matcheaba nunca y la pantalla contestaba "no hay recorrido registrado"
              * para cualquier vigilante y cualquier fecha, hubiera datos o no.
              * Por eso el `id` se copia explicitamente.
              */
            usersList () {
                return this.users.map(u => ({
                    ...u,
                    id: u.id,
                    fullName: (u.first_name || '') + ' ' + (u.last_name || '') + (u.role ? ' (' + u.role + ')' : '')
                }))
            },

            resumen () {
                if (this.puntos.length === 0) return null;
                const primero = this.puntos[0];
                const ultimo = this.puntos[this.puntos.length - 1];
                let metros = 0;
                this.segmentos.forEach(seg => {
                    for (let i = 1; i < seg.length; i++) {
                        metros += distancia(seg[i - 1].lat, seg[i - 1].lng, seg[i].lat, seg[i].lng);
                    }
                });

                // Se descuentan los huecos. De punta a punta, un turno con cuatro horas
                // de telefono apagado informaba "8 h de recorrido": el numero afirmaba
                // mas de lo que la evidencia sostiene.
                const totalMin = (ultimo.t - primero.t) / 60000;
                const huecoMin = this.huecos.reduce((a, h) => a + h.minutos, 0);

                return {
                    duracion: minutosLargos(Math.max(0, totalMin - huecoMin)),
                    span: minutosLargos(totalMin),
                    km: (metros / 1000).toFixed(2),
                    puntos: this.puntos.length
                }
            },

            // Puntos cuyo reloj de telefono se aparta mas de cinco minutos del reloj
            // del servidor. Un desfase parejo en todo un turno es un reloj cambiado a
            // mano; uno grande y aislado es un tramo que estuvo en la cola offline.
            relojSospechoso () {
                const desfases = this.puntos
                    .map(p => p.desfase)
                    .filter(d => d !== null && d !== undefined)
                if (!desfases.length) return null
                const cuantos = desfases.filter(d => Math.abs(d) > 300).length
                if (!cuantos) return null
                const max = Math.max.apply(null, desfases.map(d => Math.abs(d)))
                return { cuantos, texto: max < 3600 ? Math.round(max / 60) + ' min' : Math.round(max / 3600) + ' h' }
            },

            sinMarcaServidor () {
                return this.puntos.filter(p => p.desfase === null || p.desfase === undefined).length
            },

            flechas () {
                if (!this.google) return [];
                return [{
                    icon: { path: this.google.maps.SymbolPath.FORWARD_CLOSED_ARROW, scale: 2.2, strokeColor: '#B71C1C' },
                    repeat: '140px'
                }]
            },

            puntitos () {
                if (!this.google) return [];
                return [{
                    icon: { path: 'M 0,-1 0,1', strokeOpacity: 0.7, strokeColor: '#616161', strokeWeight: 3, scale: 3 },
                    offset: '0',
                    repeat: '14px'
                }]
            },

            iconoHueco () {
                if (!this.google) return null;
                return {
                    path: this.google.maps.SymbolPath.CIRCLE,
                    scale: 12, fillColor: '#EEEEEE', fillOpacity: 1,
                    strokeColor: '#9E9E9E', strokeWeight: 2
                }
            },

            iconoDetencion () {
                if (!this.google) return null;
                return {
                    path: this.google.maps.SymbolPath.CIRCLE,
                    scale: 11, fillColor: '#1565C0', fillOpacity: 0.9,
                    strokeColor: '#FFFFFF', strokeWeight: 2
                }
            }
        },
        methods: {
            cancelarFecha () {
                this.date = this.fechaPrevia;
                this.modal = false;
            },

            openModal (punto) {
                this.markerInfo = punto;
                this.dialog = true;
            },

            abrirHueco (h) {
                this.tramoInfo = { tipo: 'hueco', desde: h.desde.t, hasta: h.hasta.t, minutos: h.minutos };
                this.dialogTramo = true;
            },

            abrirDetencion (d) {
                this.tramoInfo = { tipo: 'detencion', desde: d.desde, hasta: d.hasta, minutos: d.minutos };
                this.dialogTramo = true;
            },

            nombreDe (u) {
                if (!u) return 'Sin datos';
                // Tolera las dos formas: los documentos nuevos guardan `nombre`, los
                // viejos traian el documento completo del usuario.
                if (u.nombre) return u.nombre;
                return ((u.first_name || '') + ' ' + (u.last_name || '')).trim() || u.email || 'Sin datos';
            },

            minutosCortos (m) { return minutosCortos(m) },
            minutosLargos (m) { return minutosLargos(m) },

            textoDesfase (segundos) {
                const abs = Math.abs(Math.round(segundos));
                if (abs < 5) return 'sin desfase apreciable';
                const texto = abs < 60 ? abs + ' s' : Math.round(abs / 60) + ' min';
                return texto + (segundos > 0 ? ' de atraso del reloj del telefono' : ' de adelanto del reloj del telefono');
            },

            async getTraking () {
                const token = ++this.consulta;

                this.puntos = [];
                this.segmentos = [];
                this.huecos = [];
                this.detenciones = [];
                this.descartados = 0;
                this.simulados = 0;
                this.intentosSimulacion = 0;
                this.truncado = false;
                this.errorMsg = '';

                if (!this.user || !this.date) {
                    this.errorTipo = 'info';
                    this.errorMsg = 'Elegi un usuario y una fecha.';
                    return;
                }

                // El rango se cierra con `<` en el extremo superior: con `<=` el punto
                // exacto de medianoche caia en el dia anterior y en el siguiente.
                const desde = this.$moment(this.date).startOf('day').toDate();
                const hasta = this.$moment(this.date).add(1, 'days').startOf('day').toDate();

                this.cargando = true;
                this.$store.commit('setLoading', true);

                try {
                    const crudos = [];
                    let cursor = null;

                    for (;;) {
                        let consulta = db.collection('tracking')
                            .where('user.id', '==', this.user)
                            .where('timestamp', '>=', desde)
                            .where('timestamp', '<', hasta)
                            .orderBy('timestamp', 'asc')
                            .limit(PAGINA);

                        if (cursor) consulta = consulta.startAfter(cursor);

                        const pagina = await consulta.get();

                        // Si mientras se paginaba se lanzo otra consulta, esta queda
                        // obsoleta y sus resultados se tiran.
                        if (token !== this.consulta) return;

                        pagina.forEach(doc => crudos.push(doc.data()));

                        if (pagina.size < PAGINA) break;
                        if (crudos.length >= MAX_PUNTOS) { this.truncado = true; break; }
                        cursor = pagina.docs[pagina.docs.length - 1];
                    }

                    if (crudos.length === 0) {
                        this.errorTipo = 'info';
                        this.errorMsg = 'No hay recorrido registrado para esta persona en esta fecha.';
                        return;
                    }

                    this.procesar(crudos);

                    // Los puntos simulados se rechazan en el dispositivo, asi que no
                    // estan en `tracking`: el intento queda en `alertas_integridad`.
                    // Sin esta consulta el trabajo de deteccion no se veia en ninguna
                    // parte del panel.
                    try {
                        const alertas = await db.collection('alertas_integridad')
                            .where('user.id', '==', this.user)
                            .where('timestamp', '>=', desde)
                            .where('timestamp', '<', hasta)
                            .get();
                        if (token === this.consulta) this.intentosSimulacion = alertas.size;
                    } catch (e) {
                        // Si falta el indice o falla la consulta, el recorrido se
                        // muestra igual: es informacion adicional, no el dato principal.
                    }

                    if (this.puntos.length === 0) {
                        this.errorTipo = 'warning';
                        this.errorMsg = 'Se encontraron ' + crudos.length + ' registros, pero ninguno tiene una coordenada valida.';
                        return;
                    }

                    if (this.truncado) {
                        this.errorTipo = 'warning';
                        this.errorMsg = 'El recorrido supera los ' + MAX_PUNTOS + ' puntos y se muestra recortado. Suele indicar deriva del GPS.';
                    }

                    this.$nextTick(() => this.ajustarVista());
                } catch (error) {
                    if (token !== this.consulta) return;
                    this.errorTipo = 'error';
                    this.errorMsg = 'No se pudo cargar el recorrido. Revisa la conexion e intenta de nuevo.';
                } finally {
                    // El commit va DENTRO del guard: una consulta vieja que termina
                    // -incluso de otra instancia de la vista, tras navegar y volver-
                    // apagaba el overlay de una consulta nueva que seguia en vuelo.
                    if (token === this.consulta) {
                        this.cargando = false;
                        this.fechaPrevia = this.date;
                        this.$store.commit('setLoading', false);
                    }
                }
            },

            /**
             * Saneado, segmentacion y detenciones.
             *
             * El saneado no es opcional: `setPath` de Google Maps lanza
             * InvalidValueError dentro del watcher de la libreria -donde no hay
             * try/catch posible- si un solo punto trae una coordenada invalida, y el
             * mapa entero queda sin dibujar. Y un 0,0, que Android reporta cuando
             * pierde el fix, dibujaba una recta hasta el golfo de Guinea.
             */
            procesar (crudos) {
                const puntos = [];

                // El usuario es el mismo para todo el recorrido: se resuelve una sola
                // vez. Antes cada punto guardaba `raw: d`, o sea el documento completo,
                // y con documentos viejos -que traian el objeto `user` entero con
                // email, area y asignacion- 20.000 puntos retenian decenas de MB.
                this.usuarioRecorrido = crudos.length ? (crudos[0].user || null) : null;

                crudos.forEach(d => {
                    const lat = Number(d.latitude);
                    const lng = Number(d.longitude);

                    if (!Number.isFinite(lat) || !Number.isFinite(lng)
                        || Math.abs(lat) > 90 || Math.abs(lng) > 180
                        || (lat === 0 && lng === 0)) {
                        this.descartados++;
                        return;
                    }

                    if (d.simulated === true) {
                        this.simulados++;
                        this.descartados++;
                        return;
                    }

                    const t = aFecha(d.timestamp);
                    if (!t) { this.descartados++; return; }

                    // Diferencia entre el reloj del telefono y el del servidor. Es la
                    // señal de manipulacion: un desfase parejo en todo un turno es un
                    // reloj cambiado a mano.
                    const recibido = aFecha(d.recibidoEn);
                    const desfase = recibido ? (recibido.getTime() - t.getTime()) / 1000 : null;

                    puntos.push({
                        lat,
                        lng,
                        t: t.getTime(),
                        accuracy: Number.isFinite(d.accuracy) ? d.accuracy : null,
                        speed: Number.isFinite(d.speed) ? d.speed : null,
                        desfase
                    });
                });

                // Etiqueta de distancia y tiempo respecto del punto anterior, para el
                // detalle.
                for (let i = 1; i < puntos.length; i++) {
                    const m = distancia(puntos[i - 1].lat, puntos[i - 1].lng, puntos[i].lat, puntos[i].lng);
                    const s = (puntos[i].t - puntos[i - 1].t) / 1000;
                    puntos[i].desdeAnterior = Math.round(m) + ' m en ' + (s < 90 ? Math.round(s) + ' s' : minutosCortos(s / 60));
                }

                const cortes = segmentar(puntos, HUECO_MINUTOS);

                this.puntos = puntos;
                this.segmentos = cortes.segmentos;
                this.huecos = cortes.huecos;

                // Las detenciones se buscan DENTRO de cada segmento, nunca cruzando un
                // hueco. Si se corriera sobre el arreglo completo, un telefono apagado
                // cuatro horas en la porteria produciria dos puntos a menos de 25 m
                // separados por cuatro horas, y eso se dibujaria como una "detencion de
                // 4 h": el mismo invento de evidencia que la segmentacion de huecos
                // existe para evitar, reintroducido por la otra punta.
                this.detenciones = cortes.segmentos.reduce(
                    (acc, seg) => acc.concat(detectar(seg, RADIO_DETENCION, DETENCION_MINUTOS)),
                    []
                );
            },

            ajustarVista () {
                // Sin esto el mapa quedaba en zoom 12 fijo, centrado en el primer
                // punto: una ronda dentro de un conjunto mide 150-400 m y ocupaba
                // menos de diez pixeles.
                //
                // No se chequea `this.google`: el script de Maps recien empieza a
                // cargar en el mounted del mapa, y Firestore suele responder antes, asi
                // que el guard hacia que el PRIMER recorrido de cada sesion no se
                // ajustara. `$mapPromise` ya resuelve despues de que el API cargo.
                if (!this.$refs.mapa || this.puntos.length === 0) return;

                this.$refs.mapa.$mapPromise.then(mapa => {
                    if (this.puntos.length === 1) {
                        mapa.setCenter({ lat: this.puntos[0].lat, lng: this.puntos[0].lng });
                        mapa.setZoom(17);
                        return;
                    }
                    const limites = new this.google.maps.LatLngBounds();
                    this.puntos.forEach(p => limites.extend({ lat: p.lat, lng: p.lng }));
                    mapa.fitBounds(limites, 48);
                }).catch(() => {});
            }
        },
        watch: {
            // El autocomplete solo calcula su texto visible al montarse y al cambiar el
            // valor. Si se asigna `user` en created(), cuando la lista de usuarios
            // todavia esta vacia (`bindUsers` es async), el campo queda EN BLANCO para
            // siempre aunque el recorrido se dibuje bien. Por eso se espera la lista.
            usersList (lista) {
                if (this.userPendiente && lista.length) {
                    this.user = this.userPendiente;
                    this.userPendiente = null;
                    this.$nextTick(() => this.getTraking());
                }
            }
        },
        beforeDestroy () {
            // Invalida cualquier consulta en vuelo y libera el overlay global: si no,
            // una consulta larga que termina despues de salir de la pantalla apagaba
            // el overlay de lo que estuviera cargando en ese momento.
            this.consulta++;
            this.$store.commit('setLoading', false);
        },
        created () {
            // Se puede llegar desde la pantalla "En vivo" con el vigilante y la fecha
            // ya elegidos: /tracking?user=<id>&fecha=YYYY-MM-DD
            // Se validan como texto: con `?user=a&user=b` la query llega como arreglo.
            const q = this.$route.query || {};
            if (typeof q.fecha === 'string' && this.$moment(q.fecha, 'YYYY-MM-DD', true).isValid()) {
                this.date = q.fecha;
                this.fechaPrevia = q.fecha;
            }
            if (typeof q.user === 'string' && q.user) {
                this.userPendiente = q.user;
                // Si la lista ya estaba cargada, el watcher no va a disparar.
                if (this.usersList.length) {
                    this.user = q.user;
                    this.userPendiente = null;
                    this.$nextTick(() => this.getTraking());
                }
            }
            // Ya no se pide la ubicacion del navegador del supervisor: no aporta nada
            // para auditar a otra persona, y si el permiso se concedia despues de
            // cargar un recorrido, el mapa saltaba a la oficina y dejaba la ronda
            // fuera de pantalla.
        }
    }

    // ------------------------------------------------------------------ Auxiliares

    function aFecha (valor) {
        if (!valor) return null;
        if (typeof valor.toDate === 'function') return valor.toDate();
        if (valor instanceof Date) return valor;
        if (valor.seconds) return new Date(valor.seconds * 1000);
        return null;
    }

    function distancia (lat1, lng1, lat2, lng2) {
        const R = 6371000;
        const rad = Math.PI / 180;
        const dLat = (lat2 - lat1) * rad;
        const dLng = (lng2 - lng1) * rad;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
            + Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function segmentar (puntos, huecoMinutos) {
        const segmentos = [];
        const huecos = [];
        if (puntos.length === 0) return { segmentos, huecos };

        let actual = [puntos[0]];

        for (let i = 1; i < puntos.length; i++) {
            const minutos = (puntos[i].t - puntos[i - 1].t) / 60000;
            if (minutos > huecoMinutos) {
                if (actual.length > 0) segmentos.push(actual);
                huecos.push({ desde: puntos[i - 1], hasta: puntos[i], minutos });
                actual = [puntos[i]];
            } else {
                actual.push(puntos[i]);
            }
        }
        if (actual.length > 0) segmentos.push(actual);

        // Un segmento de un solo punto no dibuja nada; se descarta del trazado pero
        // el punto sigue existiendo en `puntos`.
        return { segmentos: segmentos.filter(s => s.length > 1), huecos };
    }

    function detectar (puntos, radio, minMinutos) {
        const paradas = [];
        let i = 0;

        // Tope defensivo del escaneo interno. En los dos casos reales -garita quieta
        // todo el turno, o movimiento continuo- esto es lineal. El caso patologico
        // necesita miles de puntos dentro del radio que abarquen menos de `minMinutos`,
        // y ahi sin tope serian k^2/2 haversines y la pestania se congela.
        const TOPE = 3000;

        while (i < puntos.length) {
            let j = i + 1;
            const limite = Math.min(puntos.length, i + TOPE);
            while (j < limite && distancia(puntos[i].lat, puntos[i].lng, puntos[j].lat, puntos[j].lng) <= radio) j++;

            const ultimo = j - 1;
            const minutos = (puntos[ultimo].t - puntos[i].t) / 60000;

            if (ultimo > i && minutos >= minMinutos) {
                let sumaLat = 0;
                let sumaLng = 0;
                for (let k = i; k <= ultimo; k++) { sumaLat += puntos[k].lat; sumaLng += puntos[k].lng; }
                const n = ultimo - i + 1;
                paradas.push({
                    lat: sumaLat / n,
                    lng: sumaLng / n,
                    desde: puntos[i].t,
                    hasta: puntos[ultimo].t,
                    minutos,
                    puntos: n
                });
                i = j;
            } else {
                i++;
            }
        }

        return paradas;
    }

    function minutosCortos (m) {
        if (!Number.isFinite(m)) return '-';
        if (m < 1) return '<1m';
        if (m < 60) return Math.round(m) + 'm';
        return Math.floor(m / 60) + 'h' + (Math.round(m % 60) > 0 ? Math.round(m % 60) + 'm' : '');
    }

    function minutosLargos (m) {
        if (!Number.isFinite(m)) return 'sin datos';
        if (m < 1) return 'menos de 1 minuto';
        if (m < 60) return Math.round(m) + ' minutos';
        const horas = Math.floor(m / 60);
        const resto = Math.round(m % 60);
        return horas + ' h' + (resto > 0 ? ' ' + resto + ' min' : '');
    }
</script>

<style scoped>
    .resumen {
        display: flex;
        flex-wrap: wrap;
        gap: 4px 20px;
        font-size: 13px;
        color: rgba(0, 0, 0, 0.7);
        border-top: 1px solid rgba(0, 0, 0, 0.06);
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    }

    .resumen .dato strong { color: rgba(0, 0, 0, 0.87); }
    .resumen .dato.alerta { color: #c62828; }
    .resumen .dato.alerta strong { color: #c62828; }
    .resumen .dato.aviso { color: #ef6c00; }
    .resumen .dato.aviso strong { color: #ef6c00; }
</style>
